import useEventWithDimensions from 'hooks/useEventWithDimensions';

import { ReportTemplate } from 'api/endPoints/GetReportTemplateList';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { FAVORITES } from 'components/Dashboards/Reporting/reporting.consts';
import { Button } from 'components/DesignSystem/Button';
import { CustomizedTooltip } from 'components/common';
import { SelectedTemplateWithAction } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates';
import { isTemplateBuiltByForesight } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.utils';
import { BuiltByBadge } from 'components/widgets/ReportsHome/ReportsTemplates/components/BuiltByBadge/BuiltByBadge';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/TemplateCard/TemplateCard.module.scss';
import { TemplateTagsWithVisibleLimit } from 'components/widgets/ReportsHome/ReportsTemplates/components/TemplateCard/components/TemplateTagsWithVisibleLimit/TemplateTagsWithVisibleLimit';

interface Props {
    template: ReportTemplate;
    setTemplateForAction: (value: SelectedTemplateWithAction | null) => void;
}

export const TemplateCard = ({ template, setTemplateForAction }: Props) => {
    const { sendEventWithDimensions } = useEventWithDimensions();

    const handleUseTemplate = (): void => {
        const templateType = isTemplateBuiltByForesight(template.lastUpdateUser.email) ? 'Foresight' : 'Custom';
        sendEventWithDimensions({
            category: 'Reporting',
            action: 'Create from Template Selected',
            label: `${template.name} - (${templateType})`,
        });
        setTemplateForAction({ templateId: template.id, action: 'createReport' });
    };

    return (
        <div className={classes.templateCardWrapper}>
            <div className={classes.templateHeader}>
                <h2 className={classes.title}>{template.name}</h2>

                <div className={classes.actionIcons}>
                    <div className={classes.headerActions}>
                        <div>
                            <MuiIcon
                                icon={'edit'}
                                onClick={() => {
                                    setTemplateForAction({
                                        templateId: template.id,
                                        action: 'edit',
                                    });
                                }}
                                type={'outlined'}
                                color={'var(--button-tertiary-fg)'}
                            />
                        </div>
                        <div>
                            <MuiIcon
                                icon={'delete'}
                                onClick={() => {
                                    setTemplateForAction({
                                        templateId: template.id,
                                        action: 'delete',
                                    });
                                }}
                                type={'outlined'}
                                color={'var(--button-primary-bg_destructive)'}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Bottom}
                tooltipContent={template.description}
                triggerElement={<div className={classes.description}>{template.description}</div>}
            />

            <div className={classes.cardBottom}>
                <div className={classes.tagsWrapper}>
                    <TemplateTagsWithVisibleLimit
                        tags={template.tags.map((tag) => tag.name).filter((tagName) => tagName !== FAVORITES)}
                    />
                </div>
                <div className={classes.footer}>
                    <BuiltByBadge user={template.createdBy} />
                    <Button
                        variant={'tertiary'}
                        endIcon={<MuiIcon icon={'arrow_forward'} color={'var(--button-tertiary-fg)'} />}
                        onClick={handleUseTemplate}
                    >
                        Use Template
                    </Button>
                </div>
            </div>
        </div>
    );
};
